<template>
  <div class="grid grid-cols-4 space-x-2 mb-1">
    <div class="col-span-1 flex flex-row space-x-2 items-center">
      <Button class="flex p-1 justify-center text-sm"
        color="blue"
        @click="searchDistricts">
        Search Districts
      </Button>
    </div>
    <div class="col-span-1 flex flex-row space-x-2 items-center">
      <div>District</div>
      <span
        v-if="pendingKey">
        *
      </span>
    </div>
    <div class="col-span-2 flex flex-row space-x-2 items-center">
      <input class="h-full w-3/4"
        placeholder="value"
        v-model="formValues.value.input"
        @change="() => {
          markPendingItem(formValues, 'value')
          valueChange()
        }"
      />
      <span
        v-if="pendingValue">
        *
      </span>
      <div class="grow"></div>
      <XButton class="bg-orange-200 p-1 w-4 h-4 justify-center"
        @click="() => {
          deleteKeyValue()
          valueDelete()
        }"
      />
    </div>
  </div>
</template>

<script>
import XButton from '../../XButton.vue'
import Button from '../../Button.vue'

import userManagementService from '../../../services/pages/userManagement.js'

export default {
  props: {
    defaultValue: Object,
    value: undefined,
  },
  components: {
    XButton,
    Button,
  },
  data() {
    return {
      formValues: {
        key: {
          current: 'district_code',
          input: 'district_code',
        },
        value: {
          current: undefined,
          input: undefined,
        },
      },

      pendingKey: false,
      pendingValue: false,
    }
  },
  methods: {
    deleteKeyValue() {
      this.$emit('deleteKeyValue')
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
    markPendingItem(item, type) {
      if (type === 'key') {
        this.pendingKey = true
      }
      else if (type === 'value') {
        this.pendingValue = true
      }
      this.$emit('markPending', item, type)
    },
    onAddExistingKey(existingKey) {
      this.formValues.key.input = existingKey
      this.$emit('markPending', this.formValues, 'key')
    },
    valueChange() {
      try {
        this.$emit('valueChange', 'district_code', JSON.parse(this.formValues.value.input))
      }
      catch {
        this.$emit('valueChange', 'district_code', this.formValues.value.input)
      }
    },
    valueDelete() {
      this.$emit('valueDelete', 'district_code')
    },
    searchDistricts() {
      userManagementService.openSelectorModal('district', (selectedDistrict) => {
        this.formValues.value.input = selectedDistrict.code
        this.valueChange()
        this.markPendingItem(this.formValues, 'value')
      })
    },
  },
  mounted() {
    this.formValues = this.defaultValue
    this.formValues.key.current = 'district_code'
    this.formValues.key.input = 'district_code'
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    formValues() {
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues = newValue
      this.formValues.key.current = 'district_code'
      this.formValues.key.input = 'district_code'
    },
  }
}
</script>
